export default "__VITE_ASSET__83d20c42__"